import { PaginationState } from "@tanstack/react-table";
import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import callApi from "Common/utils/apiCaller";
import { Download, ExternalLink, Plus, Search, SlidersHorizontal, X } from "lucide-react";
import { showNotification } from "Common/utils/Notification";
import moment from "moment";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Pencil, Trash2 } from "lucide-react";
import _ from "lodash";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
import * as Yup from "yup";
import { useFormik } from "formik";
import { TailSpin } from "react-loader-spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import JoditEditor, { IJoditEditorProps } from "jodit-react";
import HTMLReactParser from "html-react-parser";
import Drawer from "Common/Components/Drawer";
import { useNavigate } from "react-router-dom";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import PermissionSwitch from "../Common/Components/PermissionLocks/PermissionSwitch";
import PageTags from "Common/Components/PageTags/PageTags";

const constantPageTags = ["hr"];

const Page = () => {
  document.title = "pages | ant";

  const navigate = useNavigate();
  const [option, setOption] = useState<any>([]);
  const [pageTags, setPageTags] = useState<any>([]);
  const [loader, setLoader] = useState(false);
  const [adminData, setAdminData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [edit, setEdit] = useState<any>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [isTagModalVisible, setIsTagModalVisible] = useState<boolean>(false);
  const [editTags, setEditTags] = useState<any>([]);
  // const [url, setUrl] = useState("");
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [selectedImage, setSelectedImage] = useState<any>();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const editor = useRef(null);

  const [content, setContent] = useState<any>("");
  const debouncedHandler = useCallback(
    _.debounce((user: any, pagination: any, render: any, edit: any) => {
      return fetchDateWithFilters(user, pagination, render, edit);
    }, 700),
    []
  );

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
      permission: profile.permission,
    })
  );

  const { error, success, user, permission } = useSelector(selectProperties);

  async function fetchDateWithFilters(
    searchByName: any,
    pagination: any,
    render: any,
    edit: any
  ) {
    let filters: { [index: string]: any } = {};
    if (searchByName) {
      filters.qtext = searchByName;
    }
    if (edit) {
      filters.is_edit = edit;
    } else if (edit === false) {
      filters.is_edit = edit;
    }
    filters.tags = constantPageTags;
    setLoader(true);
    const localData = await callApi("v1/page/list", "post", {
      pageNum: pagination.pageIndex + 1,
      pageSize: pagination.pageSize,
      filters,
    });
    setLoader(false);
    if (localData.status === "Success") {
      setAdminData(localData.data.pageList);
      setPageCount(Math.ceil(localData.data.pageCount / pagination.pageSize));
      setTotalItems(localData.data.pageCount);
    }
  }

  useEffect(() => {
    debouncedHandler(search, pagination, render, edit);
  }, [pagination, render, search, edit]);

  // const fetchAdminList = async () => {
  //   setLoader(true);
  //   const localData = await callApi("v1/page/list", "post", {
  //     pageNum: pagination.pageIndex + 1,
  //     pageSize: pagination.pageSize,
  //   });
  //   setLoader(false);
  //   if (localData.status === "Success") {
  //     setAdminData(localData.data.pageList);
  //     setPageCount(Math.ceil(localData.data.pageCount / pagination.pageSize));
  //     setTotalItems(localData.data.pageCount);
  //   }
  // };

  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ["name", "designation", "location", "email", "status"];
    setSearch(search);
  };

  const handleEditChange = (selectedOption: any) => {
    if (selectedOption.value === "select") {
      setEdit(null);
    } else if (selectedOption.value === "unedit") {
      let value1: boolean = false;
      setEdit(value1);
    } else if (selectedOption.value === "edit") {
      let value1: boolean = true;
      setEdit(value1);
    }
  };

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      //dispatch(onDeleteEmployee(eventData.id));
      setLoader(true);
      try {
        const res = await callApi(`v1/page/${eventData?._id}/delete`, "post", {
          page: { is_deleted: true },
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          setDeleteModal(false);
          setRender(!render);
          toast("Removed successfully");
        } else {
          toast(res.data.error);
        }
      } catch (e) {
        console.log(e);

        toast("e");
      }
    }
  };
  //
  useEffect(() => {
    fetchData("edit_code");
    fetchPageTags();
  }, []);

  const fetchData = async (code) => {
    try {
      const res = await callApi(`v1/content/code/${code}`, "get", {});
      if (res.status === "Success") {
        setOption(res.data.content.params);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };

  const fetchPageTags = async () => {
    const res = await callApi(`v1/content/code/page-tags`, "get", {});
    if (res.status === "Success") {
      setPageTags(res.data.content.params);
    }
  };

  // Update Data
  const handleUpdateDataClick = (item: any) => {
    // setEventData({ ...ele });
    // setIsEdit(true);
    // setShow(true);
    navigate(`/page/${item._id}/view`);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (eventData && eventData.title) || "",
      url: (eventData && eventData.url) || "",
      module: (eventData && eventData.module) || "",
    },

    validationSchema: Yup.object({
      title: Yup.string().required("Please enter  title"),
      url: Yup.string().required("Please enter  url"),
      module: Yup.string().required("Please enter module"),
    }),
    onSubmit: async (values) => {
      if (isEdit) {
        const updateData = {
          _id: eventData ? eventData._id : 0,
          ...values,
        };
        // update user
        try {
          setLoader(true);
          const res = await callApi(
            `v1/page/${eventData?._id}/update`,
            "post",
            {
              page: {
                title: values?.title,
                url: values?.url,

                module: values?.module,
              },
            }
          );
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            toast("Updated successfully");
          } else {
          }
        } catch (e) {
          toast("something went wrong");
        }
      } else {
        try {
          setLoader(true);
          const res = await callApi(`v1/page/new-page`, "post", {
            page: {
              title: values?.title,
              url: values?.url,
              meta_keyword: " ",
              meta_description: " ",
              module: values?.module,
              canonical_url: values?.url,
              page_title: values?.title,
            },
          });
          setLoader(false);
          if (res && res?.status === "Success") {
            setRender(!render);
            toast("Page created successfully");
          }
        } catch (e) {
          toast(e.response.data.data.message);
        }
      }
      toggle();
    },
  });

  const handleEditTags = (data: any) => {
    setIsTagModalVisible(true);
    setEditTags(data);
  };

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      setSelectedImage("");
      setContent("");
    } else {
      setShow(true);
      setEventData("");
      setSelectedImage("");
      validation.resetForm();
      setContent("");
    }
  }, [show, validation]);

  const adminListColumns = useMemo(
    () => [
      {
        header: "Title",
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Url",
        accessorKey: "url",
        enableColumnFilter: false,
        enableSorting: false,
      },

      {
        header: "MetaDescription",
        accessorKey: "meta_description",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["page:read"]}
              yes={
                <div
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md cursor-pointer size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    handleUpdateDataClick(data);
                  }}
                >
                  <Pencil className="size-4" />
                </div>
              }
              no={<span></span>}
            />

            {cell.row.original.isDeleteNotAllowed ? null : (
              <PermissionSwitch
                hasPermissions={permission.permissions}
                shouldHavePermissions={["page:delete"]}
                yes={
                  <Link
                    to="#!"
                    className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                    onClick={() => {
                      const data = cell.row.original;
                      onClickDelete(data);
                    }}
                  >
                    <Trash2 className="size-4" />
                  </Link>
                }
                no={<span></span>}
              />
            )}
          </div>
        ),
      },
      {
        header: "description",
        accessorKey: "meta_keyword",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <>{HTMLReactParser(cell.row.original.meta_keyword ?? "")}</>
        ),
      },
      {
        header: "Website Url",
        accessorKey: "url",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <>
            {!cell?.row?.original?.is_published ? (
              <span style={{ color: '#999', cursor: 'not-allowed' }}>View Website</span>
            ) : (
              <a href={`${process.env.REACT_APP_URL}/${cell.row.original.url}`} target="_blank">
                <div className="flex items-center gap-2">
                  View Website <ExternalLink className="size-4" />
                </div>
              </a>)}
          </>
        ),
      },
      {
        header: "Preview Url",
        accessorKey: "url",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <a href={`${process.env.REACT_APP_PREVIEW_URL}/${cell.row.original.url}?is_preview=${cell.row.original._id}`} target="_blank">
            <div className="flex items-center gap-2">
              Preview <ExternalLink className="size-4" />
            </div>
          </a>
        ),
      },
      {
        header: "Edit Status",
        accessorKey: "is_edit",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => <>{cell.getValue() ? "Edited" : "UnEdited"}</>,
      },
      {
        header: "Approved By",
        accessorKey: "approved_by",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => {
          const { approved_by } = row.original;

          return (
            <div>
              <span>{approved_by?.contact_name || ""}</span>
            </div>
          );
        }
      },
      {
        header: "Approved At",
        accessorKey: "approved_at",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => {
          const { approved_at } = row.original;

          const date = new Date(approved_at);
          const formattedDate = date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          });

          return (
            <div>
              <span>{approved_at && (formattedDate || "")}</span>
            </div>
          );
        }
      },
      {
        header: "Published By",
        accessorKey: "published_by",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => {
          const { published_by } = row.original;

          return (
            <div>
              <span>{published_by?.contact_name || ""}</span>
            </div>
          );
        }
      },
      {
        header: "Published At",
        accessorKey: "published_at",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => {
          const { published_at } = row.original;

          const date = new Date(published_at);
          const formattedDate = date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          });

          return (
            <div>
              <span>{published_at && (formattedDate || "")}</span>
            </div>
          );
        }
      },
      {
        header: "Module",
        accessorKey: "module",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Tags",
        accessorKey: "tags",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <p>{cell.row.original.tags?.join(",")}</p>
            <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["pagetag:edit"]}
              yes={
                <div
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md cursor-pointer size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    handleEditTags(data);
                  }}
                >
                  <Pencil className="size-4" />
                </div>
              }
              no={<span></span>}
            />
          </div>
        ),
      },
    ],
    [permission.permissions]
  );

  const updateTags = async (data: any, tags: any) => {
    try {
      setLoader(true);
      const res = await callApi(`v1/page/${data?._id}/update`, "post", {
        page: { tags: tags },
      });
      setLoader(false);
      if (res && res?.status === "Success") {
        setIsTagModalVisible(false);
        debouncedHandler(search, pagination, render, edit);
        showNotification("Tags updated successfully", "success");
      } else {
        showNotification("Something went wrong", "error");
      }
    } catch (e) {
      showNotification("Something went wrong", "error");
    }
  };

  return (
    <React.Fragment>
      <BreadCrumb title="HR Pages" pageTitle="Pages" version="" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="card-body">
            <div className="flex items-center">
              <h6 className="text-15 grow">Pages</h6>
              <div className="shrink-0">
                {/* <PermissionSwitch
                  hasPermissions={permission.permissions}
                  shouldHavePermissions={["page:create"]}
                  yes={
                    <button
                      type="button"
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={toggle}
                    >
                      <Plus className="inline-block size-4" />{" "}
                      <span className="align-middle">Add Pages</span>
                    </button>
                  }
                  no={
                    <button
                      type="button"
                      disabled={true}
                      className="text-grey btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={null}
                    >
                      <Plus className="inline-block size-4" />{" "}
                      <span className="align-middle">Add Pages</span>
                    </button>
                  }
                /> */}
              </div>
            </div>
          </div>
          <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
            <form action="#!">
              <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                <div className="relative xl:col-span-3">
                  <input
                    type="text"
                    className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Search for page title..."
                    autoComplete="off"
                    onChange={(e) => filterSearchData(e)}
                  />
                  <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                </div>
                {option?.length !== 0 && (
                  <div className="xl:col-span-2">
                    <Select
                      className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      options={option}
                      isSearchable={false}
                      defaultValue={option[0]}
                      onChange={(event: any) => handleEditChange(event)}
                      id="choices-single-default"
                    />
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className="card-body">
            <TableContainer
              isPagination={true}
              columns={adminListColumns || []}
              data={adminData || []}
              pageCount={pageCount}
              pagination={pagination}
              totalItems={totalItems}
              onPaginationChange={(updater: any) => {
                const nextState = updater(pagination);
                if (nextState.pageIndex !== pagination.pageIndex)
                  setPagination(nextState);
              }}
              divclassName="overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
            />
          </div>
        </div>
      </div>
      {/* Employee Modal */}
      <Drawer
        show={show}
        onHide={toggle}
        id="defaultModal"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">
            {!!isEdit ? "Edit Pages" : "Add Pages"}
          </Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <input type="hidden" value="" name="id" id="id" />
            <input type="hidden" value="add" name="action" id="action" />
            <input type="hidden" id="id-field" />
            <div
              id="alert-error-msg"
              className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
            ></div>
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-12">
                <label
                  htmlFor="title"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Title
                </label>
                <input
                  type="text"
                  id="title"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Enter page title"
                  name="title"
                  onChange={validation.handleChange}
                  value={validation.values.title || ""}
                />
                {validation.touched.title && validation.errors.title ? (
                  <p className="text-red-400">{validation.errors.title}</p>
                ) : null}
              </div>
              <div className="xl:col-span-12">
                <label
                  htmlFor="url"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Url
                </label>
                <input
                  type="text"
                  id="url"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Enter url"
                  name="url"
                  onChange={validation.handleChange}
                  value={validation.values.url || ""}
                />
                {validation.touched.url && validation.errors.url ? (
                  <p className="text-red-400">{validation.errors.url}</p>
                ) : null}
              </div>

              <div className="xl:col-span-12">
                <label
                  htmlFor="module"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Module
                </label>
                <input
                  type="text"
                  id="module"
                  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder="Enter Module"
                  name="module"
                  onChange={validation.handleChange}
                  value={validation.values.module || ""}
                />
                {validation.touched.module && validation.errors.module ? (
                  <p className="text-red-400">{validation.errors.module}</p>
                ) : null}
              </div>
            </div>

            <div className="flex justify-end gap-2 mt-4">
              <button
                type="reset"
                id="close-modal"
                data-modal-close="addEmployeeModal"
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                type="submit"
                id="addNew"
                disabled={loader}
                style={{
                  minWidth: "130px",
                  display: "flex",
                  justifyContent: "center",
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? (
                  <span>
                    <TailSpin
                      visible={true}
                      height="20"
                      width="20"
                      color="#fff"
                    />
                  </span>
                ) : !!isEdit ? (
                  "Update Pages"
                ) : (
                  "Add Pages"
                )}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>
      {isTagModalVisible ?
        <PageTags
          editTags={editTags}
          show={isTagModalVisible}
          toggle={() => setIsTagModalVisible(!isTagModalVisible)}
          loader={loader}
          option={pageTags}
          updateTags={updateTags}
        />
        : null}
    </React.Fragment>
  );
};

export default Page;
